import React, { useEffect } from 'react' 
import { useAppContext } from "../Context/Store";
import parse from 'html-react-parser';

export default function PrivacyPolicyPage({ sendBodyClass }) {
    const { isError, isLoading, PrivacyPolicyData } = useAppContext();
//PrivacyPolicyData

if(isError){
  //console.log("Home Page Component", contextData); 
  return <div>Error Privacy Policy Page...</div>;  // Handle Error state
}

if (!PrivacyPolicyData || isLoading) {
  return <div>Loading...</div>;  // Handle loading state
}

const { properties } = PrivacyPolicyData;
//console.log(PrivacyPolicyData);
    useEffect(() => {
      sendBodyClass(false);
    },[])
  return (
    <>
      <section className="about-txt faqs">
        <div className="inner">
            <article>
                <div className="info">
                {parse(`${properties?.descriptionText?.markup || " "}`)}
                </div> 
            </article> 
        </div>
    </section> 
    </>
  )
}